import React, {useContext, useEffect, useState} from 'react';
import OverviewContext from "../contexts/OverviewContext";
import {ViewType} from '../types'
import LocResourcesContext from "../../../common/src/contexts/LocResourcesContext";
import LoadingSkeleton from '../../../common/src/components/LoadingSkeleton';
import EntriesComponent from '../components/EntriesComponent';
import ExchangeRateExampleComponent from '../components/ExchangeRateExampleComponent';
import Banner from "../../../common/src/components/Banner";
import GiftBanner from "../../../common/src/components/GiftBanner";
import SkeletonCustomerBalance from "../../../common/src/components/SkeletonCustomerBalance";
import CustomerBalance from "../../../common/src/components/CustomerBalance";

type OverviewComponentProps = {
    view: ViewType;
    siteDomain: string;
}

const OverviewComponent: React.FC<OverviewComponentProps> = ({view, siteDomain}) => {
    const SET_TIMEOUT_TIMER = 10000;
    const { onSendingMetricEvent,
        entries,
        exchangeRateExample,
        bonusPointsOverview,
        giftAmount,
        giftStatus,
        hasAnyRedemption,
        redeemableBalance} = useContext(OverviewContext);
    const { locResources} = useContext(LocResourcesContext);
    const [isOverviewDataReady, setIsOverviewDataReady] = useState<boolean>(false);
    const [isRenderFailed, setIsRenderFailed] = useState<boolean>(false);

    const renderSuccess = () => {
        setIsRenderFailed(false);
        onSendingMetricEvent('renderSuccess');
    }

    const renderCustomerBalanceSkeleton = (): boolean => {
        return view === ViewType.Private && (giftStatus === undefined || giftStatus) && redeemableBalance === null
    }

    const renderCustomerBalance = (): boolean => {
        return view === ViewType.Private && (giftStatus === undefined || giftStatus) && redeemableBalance > 0;
    }

    useEffect(() => {
        if (isOverviewDataReady) {
            renderSuccess();
        }
        const metricsTimeout = setTimeout(() => {
            if (!isOverviewDataReady) setIsRenderFailed(true)
        }, SET_TIMEOUT_TIMER);
        return function() {
            clearTimeout(metricsTimeout);
        }
    }, [isOverviewDataReady])

    useEffect(() => {
        (view === ViewType.Private)
            ? setIsOverviewDataReady(locResources && locResources.length !== 0
                && entries !== null && !!exchangeRateExample && bonusPointsOverview !== null)
            : setIsOverviewDataReady(locResources && locResources.length !== 0)

    }, [locResources, entries, exchangeRateExample]);

    return (isOverviewDataReady) ? (
        <>
            <Banner siteDomain={siteDomain}
                  view={view}
                  defaultTitle={"loy.points.bannertitle"}
                  defaultSubtitle={"loy.points.bannersubtitle"}
                  bannerName={"overview.jpg"}
                  showNewSimplifiedBanner={false}/>
            {view === ViewType.Private && giftAmount &&
            <GiftBanner showRewardShopButton={true} giftAmount={giftAmount} giftStatus={giftStatus}/>}
            {renderCustomerBalanceSkeleton() && <SkeletonCustomerBalance></SkeletonCustomerBalance>}
            {renderCustomerBalance() &&
                <CustomerBalance showRewardShopButton={true} bonusPointsOverview={bonusPointsOverview}
                                 hasAnyRedemption={hasAnyRedemption} isRewardShopPage={false}
                                 redeemableBalance={redeemableBalance}/>}
            {view === ViewType.Private && entries !== null  && <EntriesComponent entries={entries}/>}
            {view === ViewType.Private && <div className="shadow-separator hidden-xs"></div>}
            {exchangeRateExample !== null && <ExchangeRateExampleComponent exchangeRateExample={exchangeRateExample}/>}
        </>
        ) : isRenderFailed ? (
        <div></div>
    ) : (
        <>
            <LoadingSkeleton marginTop={20} height={140}></LoadingSkeleton>
            {view === ViewType.Private && <SkeletonCustomerBalance></SkeletonCustomerBalance>}
            <LoadingSkeleton height={800}></LoadingSkeleton>
        </>
    );
}

export default OverviewComponent;
